import { render, staticRenderFns } from "./ViewPurchasesPaymentPage.vue?vue&type=template&id=038e43e3"
import script from "./ViewPurchasesPaymentPage.vue?vue&type=script&lang=js"
export * from "./ViewPurchasesPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports